import React, { useState } from 'react';
import { Alert, Box, Button, TextField } from '@mui/material';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import { API_BASE_URL, fetchJson } from './api';

export default function ReportEvidenceOutputReview({ reference, entry, authHeaders, saveDocument }) {
    const [reason, setReason] = useState('');
    const [busy, setBusy] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState('');
    if (!entry?.report_evidence_snapshot_id) return null;
    async function review() {
        setBusy(true); setError(''); setResult(null);
        try {
            await saveDocument();
            const query = new URLSearchParams({ mode: 'surveyor', report_instance: entry.report_instance || 'initial' });
            const response = await fetchJson(`${API_BASE_URL}/project/${encodeURIComponent(reference)}/report-evidence/snapshots/${entry.report_evidence_snapshot_id}/output-review?${query}`, {
                method: 'POST', headers: authHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify({ report_log_id: entry.id, reason })
            });
            setResult(response.review);
        } catch (requestError) { setError(requestError.message); }
        finally { setBusy(false); }
    }
    return <Box component="section" aria-label="Saved report evidence review" sx={{ display: 'grid', gap: 1, borderTop: '1px solid', borderColor: 'divider', pt: 1.5 }}>
        <TextField fullWidth size="small" multiline minRows={2} label="Output review reason" value={reason} onChange={(event) => { setReason(event.target.value); setResult(null); }} />
        <Button variant="outlined" startIcon={<FactCheckOutlinedIcon />} onClick={review} disabled={busy || !reason.trim()} sx={{ justifySelf: 'start' }}>Review saved report evidence</Button>
        {error ? <Alert severity="error">{error}</Alert> : null}
        {result ? <Alert severity={result.validation.status === 'passed' ? 'success' : 'warning'}>
            {result.validation.status === 'passed' ? 'Saved version passed evidence checks.' : 'Saved version requires review.'}
            {` ${result.validation.unsupported_claims?.length || 0} unsupported claims; ${result.validation.incomplete_sections?.length || 0} incomplete sections.`}
        </Alert> : null}
    </Box>;
}